export default {
  TOTAL_REVENUE: 'TOTAL_REVENUE',
  NET_REVENUE: 'NET_REVENUE',
};
